module.exports = __webpack_public_path__ + "img/interior-gallery-4.c6d89677.jpg";